export enum RouteDetourErrorType {
  TotalMilesLessThanZero = 'totalMilesLessThanZero',
}
